import React from "react";
import {connect} from "react-redux";
import {cancelOrderDetail} from "../../../actions/InventoryApiActions";
import {filterPackagesWithOrderId, withWarehousePackages} from "../../../lib/WarehouseHelper";
import Form from "./OrderDetailForm";

const OrderDetailFormContainer = (props) => {
  const { warehouseId, jobId } = props;

  if (!props.warehousePackages) {
    return null;
  }
  
  const jobPackages = filterPackagesWithOrderId(props.warehousePackages, jobId);

  return <Form warehouseId={warehouseId} jobId={jobId} jobPackages={jobPackages} />;
}

export default connect(null, {
  cancelOrderDetail,
})(withWarehousePackages(OrderDetailFormContainer));
